const BCH = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0)">
      <path
        d="M10 20C15.5229 20 20.0001 15.5144 20.0001 9.98117C20.0001 4.44792 15.5229 -0.0376663 10 -0.0376663C4.4772 -0.0376663 4.57764e-05 4.44792 4.57764e-05 9.98117C4.57764e-05 15.5144 4.4772 20 10 20Z"
        fill="#0AC18E"
      />
      <path
        d="M13.3515 6.68283C12.8428 5.53389 11.6709 5.29026 10.2356 5.52787L9.77529 3.75333L8.6882 4.03304L9.14242 5.80157C8.85778 5.87376 8.56405 5.93391 8.27336 6.01512L7.81914 4.25561L6.73206 4.53533L7.19233 6.30987C6.95916 6.37604 4.99998 6.87532 4.99998 6.87532L5.29977 8.03028C5.29977 8.03028 6.09918 7.80771 6.0901 7.82576C6.5322 7.71146 6.74114 7.93103 6.83804 8.13856L8.10378 13.002C8.11892 13.1434 8.0947 13.384 7.78886 13.4652C7.80703 13.4742 6.99853 13.6667 6.99853 13.6667L7.11662 15.0142C7.11662 15.0142 9.05763 14.5209 9.31199 14.4577L9.77832 16.2533L10.8654 15.9736L10.3991 14.166C10.6989 14.0968 10.9896 14.0246 11.2712 13.9524L11.7345 15.7511L12.8216 15.4713L12.3552 13.6787C14.0298 13.2757 15.2107 12.226 14.9685 10.6229C14.814 9.65745 13.7512 8.86341 12.867 8.77318C13.412 8.29496 13.6876 7.59717 13.3515 6.68283ZM12.8276 10.9147C13.0426 12.5027 10.823 12.6982 10.0872 12.8877L9.44826 10.5116C10.1871 10.3222 12.4642 9.51609 12.8276 10.9147ZM11.4892 7.68139C11.7193 9.092 9.81768 9.25742 9.20601 9.41382L8.62461 7.2573C9.23932 7.10391 11.0229 6.37304 11.4892 7.68139Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default BCH;
